import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/exit-guide-icon.png'


_pushScopeId("data-v-feca955c")
const _hoisted_1 = { class: "guide" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchImg && _ctx.switchImg(...args))),
      class: "img",
      src: _ctx.data.currentStepImg.url
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "exit",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exitGuide && _ctx.exitGuide(...args)))
    }, [
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_ctx.lang('guide.text.exit')), 1)
    ])
  ]))
}